﻿import * as $ from 'jquery';
import { IEventAggregator } from 'common/barrels/core';
import { IResourceProvider } from 'common/resourceprovider';
import { format, escapeRegex } from 'common/functions/string';

import { IViewModelRoot } from 'runtime/controls/control';
import { IDialog, IDialogOptions } from 'runtime/dialogs/dialog';
import { WorkItemInfo } from 'runtime/data/workiteminfo';
import { UserInfo } from 'runtime/data/userinfo';
import { AssignRequested } from 'runtime/events/workitem/assignrequested';
import { TransferRequested } from 'runtime/events/workitem/transferrequested';
import { LookupItem } from 'runtime/data/lookupitem';

import * as ko from 'knockout';
import { Observable as KnockoutObservable, observable as koObservable, pureComputed as koPureComputed} from 'knockout';

export class TransferAssignDialog implements IDialog {
    options: IDialogOptions;
    private vm: TransferAssignVm;
    private dialogContent: JQuery;

    constructor(private isTransfer: boolean, workItemInfo: WorkItemInfo, targets: UserInfo[], eventAggregator: IEventAggregator, resources: IResourceProvider) {
        var vm = this.vm = new TransferAssignVm(isTransfer, this, eventAggregator, workItemInfo, resources, targets);

        var titleFormat = resources.getCoreString(isTransfer ? 'MsgTransferWorkItem' : 'MsgAssignWorkItem');

        var proceedText = resources.getCoreString('XamlProceed');

        this.options = {
            title: format(titleFormat, workItemInfo.title),
            width: 520,
            //height: 540,
            dialogClass: 'wf-container wf-worktray-item-dialog',
            buttons: [
                { text: proceedText, click: vm.proceed.bind(vm)/*, 'class': 'wf-worktray-item-dialog-proceed'*/ },
                { text: resources.getCoreString('XamlClose'), click: vm.close.bind(vm) }
            ],
            create: (/*event: Event, ui: Object*/) => {
                var $proceedButton = this.dialogContent.parent().find('button').toArray().map(x => $(x)).filter(x => x[0].innerText == proceedText)[0];
                $proceedButton.button('disable');

                vm.canProceed.subscribe(newValue => $proceedButton.button(newValue ? 'enable' : 'disable'));
            },
            open: () => ko.applyBindings(vm, this.dialogContent[0])
        };

        this.dialogContent = this.buildContent(isTransfer, workItemInfo, eventAggregator, resources);
    }

    content(): JQuery {
        return this.dialogContent;
    }

    close(): void {
        this.dialogContent.dialog('close');
    }

    private buildContent(isTransfer: boolean, workItemInfo: WorkItemInfo, eventAggregator: IEventAggregator, resources: IResourceProvider): JQuery {
        var $parent = $('<div />');

        $('<div />').addClass('form-group').append([
            $('<label />').addClass('control-label').text(resources.getCoreString('XamlTitle')),
            $('<span />').addClass('form-control-static').append($('<span />').text(workItemInfo.title))
        ]).appendTo($parent);

        $('<div />').addClass('form-group').append([
            $('<label />').addClass('control-label').text(resources.getCoreString('XamlType')),
            $('<span />').addClass('form-control-static').append($('<span />').text(workItemInfo.definitionTitle))
        ]).appendTo($parent);

        $('<div />').addClass('form-group').append([
            $('<label />').addClass('control-label').text(resources.getCoreString('XamlStep')),
            $('<span />').addClass('form-control-static').append($('<span />').text(workItemInfo.stepName))
        ]).appendTo($parent);

        if (workItemInfo.claimUserInfo !== undefined && workItemInfo.claimUserInfo !== null) {
            $('<div />').addClass('form-group').append([
                $('<label />').addClass('control-label').text(resources.getCoreString('XamlClaimedBy')),
                $('<span />').addClass('form-control-static').append($('<span />').text(workItemInfo.claimUserInfo.displayName))
            ]).appendTo($parent);
        }

        $('<div />').addClass('form-group').append([
            $('<label />').addClass('control-label').text(resources.getCoreString(isTransfer ? 'XamlTransferTo' : 'XamlAssignTo')),
            $('<div />').addClass('form-control-static').append([
                $('<div />').addClass('wf-dialog-target-user-list').append([
                    $('<div />').attr('data-bind', 'autoCompleteList: { selectedValue: targetUserId, context: \'targetUser\', filteredLookupItems: getTargetUsers, options: { contentMinimumPrefixLength: 0 } }')
                ])
            ])
        ]).appendTo($parent);

        $('<div />').addClass('form-group').append($('<span />').text(isTransfer ? resources.getCoreString('XamlTransferAssignDialogTransferMessage') : resources.getCoreString('XamlTransferAssignDialogAssignMessage'))).appendTo($parent);

        return $parent;
    }
}

class TransferAssignVm implements IViewModelRoot {
    eventAggregator: IEventAggregator;
    resources: IResourceProvider;

    targetUserId: KnockoutObservable<string>;

    private isTransfer: boolean;
    private parentDialog: TransferAssignDialog;
    private workItemInfo: WorkItemInfo;
    private targets: UserInfo[];

    constructor(isTransfer: boolean, parentDialog: TransferAssignDialog, eventAggregator: IEventAggregator, workItemInfo: WorkItemInfo, resources: IResourceProvider, targets: UserInfo[]) {
        this.targetUserId = koObservable<string>();
        this.isTransfer = isTransfer;
        this.parentDialog = parentDialog;
        this.eventAggregator = eventAggregator;
        this.workItemInfo = workItemInfo;
        this.resources = resources;
        this.targets = targets;
    }

    canProceed = koPureComputed(() => {
        var userId = this.targetUserId();
        return this.targets.map(u => u.userId).indexOf(userId) > -1;
    });

    proceed(): void {
        var event = this.isTransfer
            ? new TransferRequested(this.workItemInfo, this.targetUserId(), () => this.parentDialog.close())
            : new AssignRequested(this.workItemInfo, this.targetUserId(), () => this.parentDialog.close());

        this.eventAggregator.publish(event);
    }

    close(): void {
        this.parentDialog.content().dialog('close');
    }

    getTargetUsers(filter: string): LookupItem[] {
        var rgex = new RegExp(escapeRegex(filter), 'i');
        return this.targets
            .filter(u => rgex.test(u.displayName))
            .map(u => new LookupItem(u.userId, u.displayName, [], null, true));
    }
}